import { useState } from 'react';
import { Box } from '@mantine/core';
import { useParams } from 'react-router';
import useFetch from '../../../helpers/useFetch';
import ErrorMessage from '../../ErrorMessage';
import Spinner from '../../Spinner';
import FacebookAdForm from './FacebookAdForm';

const FacebookAdsDetailsForm = ({ facebookAd, onUpdate, onDelete, onBack, onDuplicate, showUserFlow }) => {
  const fetch = useFetch();

  const [userError, setUserError] = useState();
  const [loading, setLoading] = useState(false);
  const { accountId, domainId } = useParams();

  const update = (facebookAd) => {
    setLoading(true);
    const facebookAdUpdate = { ...facebookAd };
    delete facebookAdUpdate.running;

    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/facebookAds/${facebookAdUpdate.id}`, {
      method: 'PUT',
      body: JSON.stringify(facebookAdUpdate),
    })
      .then(onUpdate)
      .catch(setUserError)
      .finally(() => setLoading(false));
  };

  const del = (cb) => {
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/facebookAds/${facebookAd.id}`, {
      method: 'DELETE',
    }).then(() => {
      if (typeof cb === 'function') {
        cb();
      }
      onDelete();
    });
  };

  if (facebookAd === undefined) {
    return (
      <>
        <Spinner />
      </>
    );
  }

  return (
    <>
      {facebookAd === null ? (
        <ErrorMessage message="Facebook Ad has been deleted." />
      ) : (
        <FacebookAdForm
          loading={loading}
          facebookAd={facebookAd}
          saveFacebookAd={update}
          deleteFacebookAd={onDelete ? del : undefined}
          onBack={onBack}
          onDuplicate={onDuplicate}
          showUserFlow={() => showUserFlow()}
        />
      )}
      {userError ? (
        <Box ta="right">
          <ErrorMessage message={userError.message} />
        </Box>
      ) : null}
    </>
  );
};

export default FacebookAdsDetailsForm;
